/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Continuity_DialogueInputs */

const en_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUITY/DIALOGUE`)
};

const fr_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUITE/DIALOGUE`)
};

const de_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KONTINUITÄT/DIALOG`)
};

const it_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUITÀ/DIALOGO`)
};

const ru_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`НЕПРЕРЫВНОСТЬ/ДИАЛОГ`)
};

const es_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUIDAD/DIÁLOGO`)
};

const zh_cn2_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续性/对话`)
};

const ja_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連続性/対話`)
};

const hi_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निरंतरता/संवाद`)
};

const pt_pt2_ccsl_export_header_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUIDADE/DIÁLOGO`)
};

/**
* | output |
* | --- |
* | "CONTINUITY/DIALOGUE" |
*
* @param {Ccsl_Export_Header_Continuity_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_continuity_dialogue = /** @type {((inputs?: Ccsl_Export_Header_Continuity_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Continuity_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "de") return de_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "it") return it_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "ru") return ru_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "es") return es_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "ja") return ja_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "hi") return hi_ccsl_export_header_continuity_dialogue(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_continuity_dialogue(inputs)
	return en_ccsl_export_header_continuity_dialogue(inputs)
});